<input
  type="text"
  [attr.name]="id"
  [attr.id]="id"
  [attr.class]="'input-text ' + styleClasses"
  [attr.placeholder]="placeholder | translate"
  (input)="update($event)"
  [value]="initialValue"
  [formControl]="control">